import { render, staticRenderFns } from "./Submittedorder.vue?vue&type=template&id=591c88f6&scoped=true"
import script from "./Submittedorder.vue?vue&type=script&lang=js"
export * from "./Submittedorder.vue?vue&type=script&lang=js"
import style0 from "./Submittedorder.vue?vue&type=style&index=0&id=591c88f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c88f6",
  null
  
)

export default component.exports